import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-085b14d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redirect" }
const _hoisted_2 = {
  key: 0,
  class: "div-page-content-area"
}
const _hoisted_3 = { class: "div-content-section" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Validating", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Don't close while checking your ID.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You will be redirected automatically from here once done.", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "default-hr" }, null, -1))
const _hoisted_10 = { class: "redirect-status" }
const _hoisted_11 = { class: "redirect-status-title" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_alert_note = _resolveComponent("custom-alert-note")!
  const _component_custom_progress_note = _resolveComponent("custom-progress-note")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.statusMessage.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.fromCognito)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.error === 'identification')
                ? (_openBlock(), _createBlock(_component_custom_alert_note, {
                    key: 0,
                    title: _ctx.store.getters.translate('identification-error'),
                    text: _ctx.store.getters.translate('alert-identification-failed-text'),
                    subtext: _ctx.store.getters.translate('alert-identification-failed-subtext'),
                    button: _ctx.store.getters.translate('generic-return'),
                    onRedirect: _ctx.returnToIdentification
                  }, null, 8, ["title", "text", "subtext", "button", "onRedirect"]))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.statusMessage.message), 1),
                (_ctx.store.getters.hasAttemptedPassportId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "buttonContinue",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryVerification && _ctx.retryVerification(...args))),
                      disabled: !_ctx.completed
                    }, _toDisplayString(_ctx.store.getters.translate("generic-continue")), 9, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.completed)
                ? (_openBlock(), _createBlock(_component_custom_progress_note, {
                    key: 1,
                    transparent: true
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (!_ctx.completed)
            ? (_openBlock(), _createBlock(_component_custom_progress_note, {
                key: 0,
                transparent: true
              }))
            : _createCommentVNode("", true)
        ]))
  ]))
}